import { render } from "./commonBgImage.vue?vue&type=template&id=356ecb8a&scoped=true"
import script from "./commonBgImage.vue?vue&type=script&lang=js"
export * from "./commonBgImage.vue?vue&type=script&lang=js"

import "./commonBgImage.vue?vue&type=style&index=0&id=356ecb8a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356ecb8a"]])

export default __exports__